import { all, call, fork, put, takeLeading } from "typed-redux-saga";
import { Action, priceListActions } from "./price-list-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { CustomerService, Model_PagedPriceListGet, ProductTypeService } from "src/backend/openapi/v1";
import { getCurrentCustomer } from "src/utils";
import { CACHE_KEYS } from "src/utils/constants";
import { getCache, saveCache } from "src/utils/cache-utils";

export function* getPriceList(action: ReturnType<typeof priceListActions.getPriceListRequest>) {
  try {
    const currentCustomer = yield* getCurrentCustomer();

    const cacheKey = CACHE_KEYS.PRICE_LIST(currentCustomer.customerId, JSON.stringify(action.payload.data));
    let result: Model_PagedPriceListGet;
    const cachedResponse = yield* call(() => getCache(cacheKey));
    if (cachedResponse) {
      result = yield* call(() => cachedResponse.json() as unknown as Model_PagedPriceListGet);
    } else {
      result = yield* call(CustomerService.postApiV1CustomerPriceList, currentCustomer.customerId, action.payload.data);
      saveCache(cacheKey, result, { memory: true });
    }

    yield put(priceListActions.getPriceListSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(priceListActions.getPriceListFail());
  }
}

export function* watchGetPriceList() {
  yield takeLeading(Action.GetPriceListRequest, getPriceList);
}

export function* getProductTypes() {
  try {
    const result = yield* call(ProductTypeService.getApiV1ProductTypes);
    yield put(priceListActions.getProductTypesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(priceListActions.getProductTypesFail());
  }
}

export function* watchGetProductTypes() {
  yield takeLeading(Action.GetProductTypesRequest, getProductTypes);
}

export function* priceListSaga() {
  yield all([fork(watchGetPriceList), fork(watchGetProductTypes)]);
}
